function getRestaurantId() {
    return localStorage.getItem("restaurantId");
  }
  
  function getHqRid() {
    return localStorage.getItem("hqRid");
  }

 module.exports = {
    getRestaurantId,
    getHqRid
  }